import { createMuiTheme } from '@material-ui/core/styles';

const primaryPurple = '#43425d';
const secondaryBlue = '#5ba9e1';
const headerGray = '#4d4f5c';
const white = '#ffffff';

export const overridings = {
  name: 'Light Theme',
  palette: {
    primary: {
      main: primaryPurple,
    },
    secondary: {
      main: secondaryBlue,
      contrastText: white,
    },
    neutral: {
      light: '#8a8998',
      main: '#bcbccb',
      dark: '#707070',
    },
    header: {
      main: headerGray,
    },
    background: {
      default: '#e6e6ea',
    },
    action: {
      active: '#3c3b54',
    },
  },
  typography: {
    fontFamily: `"Source Sans Pro", "Roboto", "Arial", sans-serif`,
    h4: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: headerGray,
    },
    h5: {
      fontSize: '1.875rem',
      fontWeight: 'bold',
      color: headerGray,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      color: headerGray,
    },
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 0,
        fontSize: '1.125em',
        textTransform: 'none',
      },
    },
    MUIDataTableToolbarSelect: {
      root: {
        display: 'none',
      },
    },
    MuiSpeedDialAction: {
      staticTooltipLabel: {
        width: 'max-content',
      },
    },
  },
};

export default createMuiTheme(overridings);
